import { message } from "antd";
import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_URL_PRO;

let isLoggingOut = false;

const CustomAxios = axios.create({
  timeout: 50000,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});
CustomAxios.interceptors.response.use(
  async (response) => {
    if (
      response.data.expired === true ||
      (response.data.error || "").toString().includes("ExpiredJwtException") ===
        true
    ) {
      try {
        const getToken = await axios.get(
          `${BASE_URL}/surfingcre/api/v1/user/issue/token`,
          {
            headers: {
              rauthorization: localStorage.getItem("rauthorization"),
            },
          }
        );
        // 재발급 응답에 에러가 있으면 토큰 만료로 로그아웃
        if (getToken.data.error) {
          if (isLoggingOut) return Promise.reject(getToken.data.error);
          isLoggingOut = true;
          message.error(
            "토큰이 만료되어 로그아웃 되었습니다. 다시 로그인해주세요."
          );
          setTimeout(() => {
            localStorage.removeItem("authorization");
            localStorage.removeItem("rauthorization");
            window.location.href = "/signin";
          }, 1000);
          return Promise.reject(getToken.data.error);
        }

        window.localStorage.setItem(
          "authorization",
          getToken.data.result.authorization
        );
        response.config.headers.authorization =
          getToken.data.result.authorization;
        return CustomAxios(response.config);
      } catch (error) {
        // 재발급 요청 실패 시 로그아웃 처리
        if (isLoggingOut) return Promise.reject(error);
        isLoggingOut = true;
        message.error("로그아웃 되었습니다. 다시 로그인해주세요.");
        setTimeout(() => {
          localStorage.removeItem("authorization");
          localStorage.removeItem("rauthorization");
          window.location.href = "/signin";
        }, 1000);
        return Promise.reject(error);
      }
    } else {
      return response;
    }
  },
  (error) => {
    // 네트워크 에러
    const isNetworkError =
      error.code === "ERR_NETWORK" ||
      error.message?.includes("Network Error") ||
      (!error.response && error.request);

    if (isNetworkError) {
      console.warn("네트워크 에러가 발생했습니다.", error);
      return Promise.reject(error);
    }

    // API 요청이 401/403, 잘못된 토큰으로 호출한 경우 로그아웃 처리
    // const status = error.response?.status;
    // const isAuthError = status === 401 || status === 403;

    // if (isAuthError) {
    //   if (isLoggingOut) return Promise.reject(error);
    //   isLoggingOut = true;
    //   message.error("로그아웃 되었습니다. 다시 로그인 해주세요.");
    //   setTimeout(() => {
    //     localStorage.removeItem("authorization");
    //     localStorage.removeItem("rauthorization");
    //     window.location.href = "/signin";
    //   }, 1000);
    //   return Promise.reject(error);
    // }

    return Promise.reject(error);
  }
);
export default CustomAxios;
